
<template>
  <el-dialog width="520px"
             v-dialog-drag
             title="添加人员"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="electricChargeVisible">
    <el-form size="small"
             ref="userForm"
             label-position="top"
             label-width="85px"
             :model="userForm"
             :rules="userFormRules" v-loading="loading">
      <el-form-item label="选择人员" prop="uids">
        <el-select key="userid" :remote-method="getUserList"  multiple  filterable placeholder="请选择" ref="mySelect3"  remote reserve-keyword  v-model="userForm.uids">
          <el-option  v-for="(item,index) in userList" :key="item.user_id"   :label="item.name"   :value="item.user_id" > </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { save798User ,CompanyUserList} from "@/api";

export default {
  name: "electricChangeAdd",
  props: {
    electricChargeVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      userForm: {
        uids: '',
      },
      userFormRules: {
        uids: [
          {required: true, message: '请选择用户', trigger: 'change'},
        ],

      },
      userList:[]
    }
  },
  created() {
    this.getUserList()
  },
  mounted() {
  },
  methods: {
    getUserList(name){
      CompanyUserList({
        company_id: 1,
        name: name,
        page: 1,
        pageSize: 15,
      }).then(res => {
        if (res.code === 200) {
          const { data, total  } = res.data
          this.userList = data
        }
        this.loading = false
      })
    },
    handleClickCancel() {
      this.$refs.userForm.resetFields()
      this.$emit('update:electricChargeVisible', false)
    },

    handleClickConfirm() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.btnDisabled = true
          save798User({
            uids: this.userForm.uids
          }).then(res => {
            this.$message.success('新增成功')
            this.$emit('success')
            this.$refs.userForm.resetFields()
            this.$emit('update:electricChargeVisible', false)
          }).catch(() => {
            this.btnDisabled = false
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.el-date-editor.el-input {
  width: 100%;
}
</style>
